import React from "react";
import {
	IonCardSubtitle,
	IonCol,
	IonGrid,
	IonItem,
	IonLabel,
	IonRow,
} from "@ionic/react";
import Spacer from "../../../../components/spacer";
import { connect } from "react-redux";

interface props {
	label: any;
	status: any;
	dates: any;
	notes: any;
	isAdmin: any;
}

const UserPhaseListItem: React.FC<props> = ({
	label,
	status,
	dates,
	notes,
	isAdmin,
}) => {
	return (
		<IonItem>
			<IonGrid>
				<IonRow>
					<IonCol sizeLg="9" sizeMd="8" sizeXs="12">
						<IonLabel className="bold">{label}</IonLabel>
						<IonCardSubtitle>{dates}</IonCardSubtitle>
						{isAdmin && (
							<>
								<Spacer size="10" />
								<div className="instructions small">{notes}</div>
							</>
						)}
					</IonCol>
					<IonCol sizeLg="3" sizeMd="4" sizeXs="12">
						{status}
					</IonCol>
				</IonRow>
			</IonGrid>
		</IonItem>
	);
};

const mapDispatch = {};

const mapState = (state: any) => ({
	isAdmin: state.user.userDetails.isAdmin,
});

export default connect(mapState, mapDispatch)(UserPhaseListItem);
